export  const weekDayToNumber = {
    "ПН": 1,
    "ВТ": 2,
    "СР": 3,
    "ЧТ": 4,
    "ПТ": 5,
    "СБ": 6,
    "ВС": 7
}